import { Component, OnDestroy, OnInit } from '@angular/core';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from '../login/login.service';
import { FormDataComment } from '../models/comment';
import { Statistics } from '../models/statistics';
import { FormDataService } from '../shared/forms/form-data.service';
import * as fromSettings from '../shared/state/setting.reducer';
import { NewCourseComponent } from '../ui/new-course/new-course.component';
import { SpinnerService } from '../ui/spinner.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  isReady = false;
  isLoggedIn = false;
  dataLoaded = {
    courseStatistics: false, competitionStatistics: false, courseComments: false, competitionComments: false,
  };
  statistics = {
    course: new Statistics,
    competition: new Statistics
  };
  comments = {
    course: new Array<FormDataComment>(),
    competition: new Array<FormDataComment>()
  };

  faSyncAlt = faSyncAlt;
  bsModalRef: BsModalRef;

  private destroy$ = new Subject<void>();

  constructor(private loginService: LoginService, private store: Store<fromSettings.SettingsState>,
    private formDataService: FormDataService, private spinnerService: SpinnerService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.spinnerService.show();
    this.loginService.isLoggedIn$.subscribe(res => {
      this.isLoggedIn = res;
    });
    this.store.select(fromSettings.getSettingsLoaded).pipe(
      takeUntil(this.destroy$)
    ).subscribe(loaded => this.isReady = loaded);

    // TODO: get latest comments belonging to users courses & competitions since last login.
    this.formDataService.myComments('course').subscribe(res => {
      this.comments.course = res.comments;
      this.dataLoaded.courseComments = true;
      this.checkIsLoaded();
    });
    this.formDataService.myComments('competition').subscribe(res => {
      this.comments.competition = res.comments;
      this.dataLoaded.competitionComments = true;
      this.checkIsLoaded();
    });
    this.formDataService.userStatistics('course').subscribe(res => {
      this.statistics.course = res.statistics;
      this.dataLoaded.courseStatistics = true;
      this.checkIsLoaded();
    });
    this.formDataService.userStatistics('competition').subscribe(res => {
      this.statistics.competition = res.statistics;
      this.dataLoaded.competitionStatistics = true;
      this.checkIsLoaded();
    });

    // TODO: get latest changes of courses & competitions workflows
  }

  checkIsLoaded(): void {
    const loadedValues = Object.values(this.dataLoaded);

    const isLoaded = loadedValues.reduce((accumulator, currentValue) => accumulator && currentValue);

    if (isLoaded) {
      this.spinnerService.hide();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  newCourseSelection() {
    const initialState = {
      title: 'Neuer Lehrgang',
      closeBtnName: 'Abbrechen',
      keyboard: true,
    };
    this.bsModalRef = this.modalService.show(NewCourseComponent, { initialState });
  }

}
